import React from 'react';
import { createIcon } from './create-icon';
import './icon-check-out.scss';

export const IconCheckOut = createIcon(<div className="icon-check-out" />);
